import { type QueryOptions } from '@tanstack/query-core'

import { type SiteDisplaySettingEntity } from '@/libs/api'

import {
  fetchSiteDisplaySetting,
  type DcsSiteDisplaySettingQuery
} from '../api'
import { dcsQueryKeys } from '../query-keys'

export const getSiteDisplaySettingOptions = (
  tenantKey: string,
  dcId: number
): Required<
  Pick<QueryOptions<SiteDisplaySettingEntity>, 'queryKey' | 'queryFn'>
> => {
  const query: DcsSiteDisplaySettingQuery = {
    dcId,
    tenantKey
  }
  return {
    queryKey: dcsQueryKeys.siteDisplaySetting(tenantKey, dcId),
    queryFn: async ({ signal }) => {
      return await fetchSiteDisplaySetting(query, signal)
    }
  }
}
